import ImageContainer from 'Component/Image/Image.container';
import { ReactElement } from 'Type/Common.type';

import HeaderLogo from './HeaderLogo.component';
import { LogoContainerProps } from './HeaderLogo.type';

/** @namespace Steinkrueger/Component/HeaderLogo/Container */
export class HeaderLogoContainer extends ImageContainer<LogoContainerProps> {
    render(): ReactElement {
        const {isSticky, isMobile} = this.props;

        return (
            <HeaderLogo
              { ...{isSticky, isMobile} }
              { ...this.containerProps() }
            />
        );
    }
}

export default HeaderLogoContainer;
